<template lang="pug">
	.real-estate-data(v-if="realEstateData")
		PropertyInterest(v-if="hashKnumber", :k-number="hashKnumber", :comission-id="realEstateData.comissionId")
		.m20-property-data-sheet-header
			.m20-property-data-sheet-header__title
				h1.real-estate-data__title {{h1}}
				h2.real-estate-data__subtitle {{h2}}
				h3.real-estate-data__subtitle {{h3}}
			.m20-property-data-sheet-header__share-block
				button(type="button", @click="openShareEmailPopup")
					svg(v-if="isMobile", width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg')
						g(opacity='0.5')
							path(d='M24 21.4403C22.9867 21.4403 22.08 21.8403 21.3867 22.467L11.88 16.9337C11.9467 16.627 12 16.3203 12 16.0003C12 15.6803 11.9467 15.3737 11.88 15.067L21.28 9.58699C22 10.2537 22.9467 10.667 24 10.667C26.2133 10.667 28 8.88033 28 6.66699C28 4.45366 26.2133 2.66699 24 2.66699C21.7867 2.66699 20 4.45366 20 6.66699C20 6.98699 20.0533 7.29366 20.12 7.60033L10.72 13.0803C10 12.4137 9.05333 12.0003 8 12.0003C5.78667 12.0003 4 13.787 4 16.0003C4 18.2137 5.78667 20.0003 8 20.0003C9.05333 20.0003 10 19.587 10.72 18.9203L20.2133 24.467C20.1467 24.747 20.1067 25.0403 20.1067 25.3337C20.1067 27.4803 21.8533 29.227 24 29.227C26.1467 29.227 27.8933 27.4803 27.8933 25.3337C27.8933 23.187 26.1467 21.4403 24 21.4403Z' fill='black')
					svg(v-else, width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
						path(d='M20 4H4C2.895 4 2.01 4.895 2.01 6L2 18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V6C22 4.895 21.105 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z' fill='#52AE30')
				Favourites(iconType="gray", :mid="realEstateData.comissionId", :liked="realEstateData.liked")
		.m20-property-data-sheet
			//- real-estate-interest(v-if="kNumber" k-number="kNumber" send-interest="sendInterestOnDataDisplayer($event)" interest-response="interestRestResponse")
			.m20-property-data-sheet-block
				.m20-property-data-sheet-main-details
					.m20-property-data-sheet-main-details__item.m20-property-data-sheet-main-details__item--price
						img.m20-property-data-sheet-main-details__icon(src="/static/assets/img/icon-property-price.svg" alt="")
						p.m20-property-data-sheet-main-details__item-param {{$t('AADAT.price')}}:
						br
						p(v-if="realEstateData.basicData.priceHuf")
							strong  {{realEstateData.basicData.priceHuf | currency}} Ft
							strong(v-if='realEstateData.basicData.priceEur') ,
						p(v-if='realEstateData.basicData.priceEur')
							strong {{realEstateData.basicData.priceEur| currency}} EUR
					.m20-property-data-sheet-main-details__item(v-if="realEstateData.basicData.area")
						img.m20-property-data-sheet-main-details__icon(src="/static/assets/img/icon-property-area.svg" alt="")
						p.m20-property-data-sheet-main-details__item-param {{$t('AADAT.area')}}:
						br
						p
							strong {{realEstateData.basicData.area}} nm
					.m20-property-data-sheet-main-details__item(v-if="realEstateData.basicData.siteArea")
						img.m20-property-data-sheet-main-details__icon(src="/static/assets/img/icon-property-area.svg" alt="")
						p.m20-property-data-sheet-main-details__item-param {{$t('AADAT.siteArea')}}:
						br
						p
							strong {{realEstateData.basicData.siteArea}} nm
					.m20-property-data-sheet-main-details__item(v-if="realEstateData.propertyData.conditionOfProperty") 
						img.m20-property-data-sheet-main-details__icon(src="/static/assets/img/icon-property-state.svg" alt="")
						p.m20-property-data-sheet-main-details__item-param {{$t('AADAT.condition')}}:
						br
						p
							strong {{$t("AADAT." + realEstateData.propertyData.conditionOfProperty)}}
					.m20-property-data-sheet-main-details__item(v-if="realEstateData.basicData.numberOfRooms")
						img.m20-property-data-sheet-main-details__icon(src="/static/assets/img/icon-property-room.svg" alt="")
						p.m20-property-data-sheet-main-details__item-param {{$t('AADAT.numOfRooms')}}:
						br
						p
							strong  {{ realEstateData.basicData.numberOfRooms }}
								span(v-if="realEstateData.basicData.numberOfHalfRooms && realEstateData.basicData.numberOfRooms") +
								span(v-if="realEstateData.basicData.numberOfHalfRooms") {{realEstateData.basicData.numberOfHalfRooms}}
				.m20-property-data-sheet-details
					// Ingatlandatok
					.m20-property-data-sheet-details__table(v-if="checkNotEmpty(realEstateData.propertyData)")
						h3.m20-property-data-sheet-details__table-title(@click="hideDetailedData=!hideDetailedData"
							:class="{'m20-property-data-sheet-details__table-title--is-open':hideDetailedData}") {{$t('AADAT.propertyDetails')}}
							span.icon-arrow-up.icon--dropdown(:class="{'icon--dropdown--is-open':!hideDetailedData}")
						.m20-property-data-sheet-details__table-row(v-for="(value, key, index) in realEstateData.propertyData" v-if="!hideDetailedData && value != false && value != 0" :class="{'odd': index % 2 === 0, 'even': index % 2 !== 0}")
							.m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--left(v-if="index % 2 !== 0 && key != 'lat' && key != 'lng' && key != 'description' && key != 'hasHiddenAddress'")
								.m20-property-data-sheet-parameters
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--attr {{$t("AADAT." + key)}}:
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsArray(value)") {{transformArray(value)}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsStringOrBoolean(value)") {{$t("AADAT." + value )}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsNumber(value)") {{value}}

							// .m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--separator
							.m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--right(v-if="index % 2 === 0 && key != 'lat' && key != 'lng' && key != 'description' && key != 'hasHiddenAddress'")
								.m20-property-data-sheet-parameters
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--attr {{$t("AADAT." + key)}}:
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsArray(value)") {{transformArray(value)}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsStringOrBoolean(value)") {{$t("AADAT." + value )}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsNumber(value)") {{value}}

					

					// Épületadatok
					.m20-property-data-sheet-details__table(v-if="checkNotEmpty(realEstateData.buildingData)")
						h3.m20-property-data-sheet-details__table-title(@click="hideBuildingData=!hideBuildingData"
							:class="{'m20-property-data-sheet-details__table-title--is-open':hideBuildingData}") {{$t('AADAT.buildingData')}}
							span.icon-arrow-up.icon--dropdown(:class="{'icon--dropdown--is-open':!hideBuildingData}")
						.m20-property-data-sheet-details__table-row(v-for="(value, key, index) in realEstateData.buildingData" v-if="!hideBuildingData && value != false && value != 0" :class="{'odd': index % 2 === 0, 'even': index % 2 !== 0}")
							.m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--left(v-if="index % 2 !== 0")
								.m20-property-data-sheet-parameters
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--attr {{$t("AADAT." + key)}}:
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsArray(value)") {{transformArray(value)}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsStringOrBoolean(value)") {{$t('AADAT.' + value)}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsNumber(value)") {{value}}

							// .m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--separator
							.m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--right(v-if="index % 2 === 0")
								.m20-property-data-sheet-parameters
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--attr {{$t("AADAT." + key)}}:
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsArray(value)") {{transformArray(value)}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsStringOrBoolean(value)") {{$t('AADAT.' + value)}}
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value(v-if="typeOfValueIsNumber(value)") {{value}}

					// Egyéb kiegészítő adatok
					.m20-property-data-sheet-details__table(v-if="checkNotEmpty(realEstateData.otherData)")
						h3.m20-property-data-sheet-details__table-title(@click="hideOtherData=!hideOtherData"
							:class="{'m20-property-data-sheet-details__table-title--is-open':hideOtherData}") {{$t('AADAT.otherData')}}
							span.icon-arrow-up.icon--dropdown(:class="{'icon--dropdown--is-open':!hideOtherData}")
						.m20-property-data-sheet-details__table-row(v-for="(value, key, index) in realEstateData.otherData" v-if="!hideOtherData && value != false && value != 0" :class="{'odd': index % 2 === 0, 'even': index % 2 !== 0}")
							.m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--left(v-if="index % 2 !== 0")
								.m20-property-data-sheet-parameters
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--attr {{$t("AADAT." + key)}}:
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value {{$t("AADAT." + value)}}
							// .m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--separator
							.m20-property-data-sheet-details__table-cell.m20-property-data-sheet-details__table-cell--right(v-if="index % 2 === 0")
								.m20-property-data-sheet-parameters
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--attr {{$t("AADAT." + key)}}:
									.m20-property-data-sheet-parameters__cell.m20-property-data-sheet-parameters__cell--value {{$t("AADAT." + value)}}
					div.about-property(v-if="descriptionTitle && $i18n.locale == 'hu'")
						h3.m20-property-data-sheet-details__title {{$t('AADAT.aboutProperty')}}
						p.m20-property-data-sheet-details__lead(v-if="!showDescriptionDetails") {{ descriptionTitle }}
						a.m20-property-data-sheet-details__more(v-if="realEstateData.propertyData.description && needsMoreButton && !showDescriptionDetails" @click="showDescriptionDetails = !showDescriptionDetails")
							span(v-if="!showDescriptionDetails") + {{$t('AADAT.moreDetails')}}
						.m20-property-data-sheet-details__desc(v-show="showDescriptionDetails && realEstateData.propertyData.description")
							p(v-html="realEstateData.propertyData.description")
							p
								a.m20-property-data-sheet-details__more(v-if="realEstateData.propertyData.description" @click="showDescriptionDetails = !showDescriptionDetails")
									span(v-if="showDescriptionDetails") - {{$t('AADAT.close')}}
					div.about-property(v-if="$i18n.locale != 'hu'")
						h3.m20-property-data-sheet-details__title {{$t('AADAT.aboutProperty')}}
						.m20-property-data-sheet-details__desc
							p Beautifull {{realEstateData.type}} in {{realEstateData.city}}. This {{realEstateData.area}} sqm {{realEstateData.type}} had been built in {{realEstateData.yearOfConstruction}}, and it's in {{realEstateData.conditionOfProperty}} condition. It's got beautifull view to {{realEstateData.view}}. If you interested plese call, or message us.
			//- .m20-property-data-sheet-additions.hide-mobile
				//- real-estate-agent(real-estate-agent="realEstateData.agent" id="realEstateData.comissionId" on-message="submitAgentMessageForm($event)" form-error="formBackendError")
				//- duty-calculator(real-estate-type="realEstateData.realEstateData.conditionOfProperty == 'newlyBuilt' ? 'new' : 'used'" real-estate-price="realEstateData.basicData.priceHuf")
				//- loan-calculator-component-2 {{$t('AADAT.similarDiscounts')}}
</template>
<script>
import romanCoverter from '../../common/js/roman-converter/roman-converter';
import realEstateApi from '../../api/real-estate-api';
import Favourites from '../../common/components/favourites/favourites';
import isMobile from '../../common/js/is-mobile/is-mobile';
import * as R from 'ramda';
import { mapActions, mapGetters } from 'vuex';
import propertyDescription from '../../common/js/property-description/property-description';
import PropertyInterest from '../../application-vue/property-interest/property-interest.vue';
const getTextContent = (html) => {
	var span = document.createElement('span');
	span.innerHTML = html;
	return span.textContent || span.innerText;
};
const BEFORE_M_NUMBER = 'ingatlan';
const URL_SEPARATOR = '/';
const getIdFromUrl = () => {
	let urlArray = window.location.pathname.split(URL_SEPARATOR);
	let index = urlArray.indexOf(BEFORE_M_NUMBER);
	return urlArray[++index];
};
const parseHashParam = R.pipe(
	R.replace('#', ''),
	R.split('/'),
	R.reject(R.equals('')),
	R.map(R.pipe(R.replace(/\+/g, ' '), decodeURIComponent, R.split('='))),
	R.fromPairs
);
const CENTRAL_AGENT = {
	id: null,
	name: null,
	phone: '+36 1 3 666 456',
	email: 'info@otpip.hu',
	careerLevel: null,
	photoUrl: null,
	central: true
};
export default {
	mixins: [isMobile, propertyDescription],
	data: () => ({
		realEstateData: null,
		showDescriptionDetails: false,
		hideDetailedData: false,
		hideBuildingData: false,
		hideRooms: false,
		hideOtherData: false,
		hashAgentId: null,
		hashKnumber: null
	}),
	components: {
		Favourites,
		PropertyInterest
	},
	watch: {
		h2(val) {
			this.setH2(val);
		},
		isLoggedIn: {
			handler(val) {
				window.ipEventBus.publish('is-logged-in-change', {
					isLoggedIn: val
				});
			},
			immediate: true
		},
		'realEstateData.liked': {
			handler(val) {
				window.ipEventBus.publish('is-liked-change', {
					isLiked: val
				});
			},
			immediate: true
		}
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn']),
		needsMoreButton() {
			return this.descriptionTitle?.length < this.realEstateData.propertyData.description.length;
		},
		excreptMaxLength() {
			return this.isMobile ? 150 : 330;
		},
		descriptionTitle() {
			return this.realEstateData.propertyData.description && this.getExcerpt(getTextContent(this.realEstateData.propertyData.description));
		},
		isBudapest() {
			return this.realEstateData && this.realEstateData.addressData.city == 'Budapest';
		},
		h1() {
			if (this.realEstateData) {
				const comissionType = this.$t(`AADAT.${this.realEstateData.comissionType}`);
				const propertyType = this.$t(`AADAT.${this.realEstateData.propertyData.type}`);
				const neighborhood = this.realEstateData.neighborhood ? `, ${this.realEstateData.neighborhood}` : '';
				if (this.isBudapest) {
					const district =
						this.realEstateData.addressData.district &&
						`, ${romanCoverter(this.realEstateData.addressData.district)}. ${this.$t('AADAT.district')}`;
					return `${comissionType} ${propertyType}${district}${neighborhood}`;
				} else {
					const city = this.realEstateData.addressData.city;
					return `${comissionType} ${propertyType}, ${city}${neighborhood}`;
				}
			}
		},
		h2() {
			return this.realEstateData && this.getPropertyDescription(this.realEstateData);
		},
		h3() {
			const city = this.realEstateData.addressData.city;
			const county = this.realEstateData.addressData.county ? `${this.realEstateData.addressData.county} ${this.$t('AADAT.countyH3')}, ` : '';
			return `${this.h2 && ', '}${county}${city}`;
		}
	},
	methods: {
		...mapActions('real-estate-data', ['setRelatedProperties', 'setRealEstateImages', 'setH2', 'setPosition']),
		async getRealEstateData() {
			const id = getIdFromUrl();
			let realEstateResponse;
			try {
				realEstateResponse = await realEstateApi.getRealEstateDataById(id);
				this.realEstateData = realEstateResponse.data.property;
				this.setRelatedProperties(realEstateResponse.data.relatedProperties);
				this.setRealEstateImages(realEstateResponse.data.property.images);
				this.setPosition({ lat: this.realEstateData.propertyData.lat, lng: this.realEstateData.propertyData.lng });
				const parkingOption = R.reject(R.equals('noGarage'), R.defaultTo([], this.realEstateData?.buildingData?.parkingOption));
				this.realEstateData.parkingOption = parkingOption;
			} catch (e) {
				console.log(e);
				window.ipEventBus.publish('show-info', {
					message: 'unavailableProperty',
					dontHide: true
				});
			}
			let agent = null;
			try {
				if (this.hashAgentId) {
					const agentResponse = await realEstateApi.getAgent(this.hashAgentId);
					agent = agentResponse.data;
				} else {
					agent = realEstateResponse.data.property.agentData;
				}
			} catch (err) {
				agent = CENTRAL_AGENT;
			}
			window.ipEventBus.publish('real-estate-agent-change', {
				agent,
				mId: realEstateResponse.data.property.comissionId
			});
			window.ipEventBus.publish('real-estate-duty-change', {
				realEstateType: realEstateResponse.data.property.propertyData.conditionOfProperty == 'newlyBuilt' ? 'new' : 'used',
				realEstatePrice: realEstateResponse.data.property.basicData.priceHuf
			});
			window.ipEventBus.publish('real-estate-loan-change', {
				realEstatePrice: realEstateResponse.data.property.basicData.priceHuf,
				condition: realEstateResponse.data.property.basicData.conditionOfProperty,
				visible:
					realEstateResponse.data.property.comissionType == 'toSell' &&
					(realEstateResponse.data.property.propertyData.type == 'house' ||
						realEstateResponse.data.property.propertyData.type == 'flat' ||
						realEstateResponse.data.property.propertyData.type == 'projectEstate')
			});
		},
		getExcerpt(text) {
			let excerpt = '';
			if (text.length > this.excreptMaxLength) {
				excerpt = text.substring(0, this.excreptMaxLength);
				excerpt = excerpt.substring(0, excerpt.lastIndexOf(' '));
				excerpt += '...';
			} else {
				excerpt = text;
			}
			return excerpt;
		},
		checkNotEmpty(thing) {
			if (typeof thing == 'object') {
				return Object.keys(thing).filter((key) => !!thing[key]).length;
			} else if (Array.isArray(thing)) {
				return thing.filter((item) => !!item).length;
			} else {
				return false;
			}
		},
		typeOfValueIsStringOrBoolean(value) {
			return typeof value == 'string' || typeof value == 'boolean';
		},
		typeOfValueIsNumber(value) {
			return typeof value == 'number';
		},
		typeOfValueIsArray(value) {
			return Array.isArray(value) && value.length;
		},
		transformArray(values) {
			return values.map((value) => this.$t(`AADAT.${value}`)).join(' ,');
		},
		openShareEmailPopup(e) {
			window.ipEventBus.publish('open-share-email-form', { comissionId: this.realEstateData.comissionId });
		},
		handleHashParam() {
			const params = parseHashParam(window.location.hash);
			this.hashAgentId = params.agent;
			this.hashKnumber = params.knumber;
		}
	},
	created() {
		this.handleHashParam();
		this.getRealEstateData();
	}
};
</script>
<style lang="css" src="@ui-common/vue-modal/dist/vue-modal.css"></style>
<style lang="css" scoped>
@import '../../common/variables.pcss';

.m20-property-data-sheet-header {
	display: flex;
	justify-content: space-between;
	padding: 0 10px;
	margin-bottom: 16px;
	@media (--desktop) {
		padding: 0;
		margin-bottom: 40px;
	}
}

.m20-property-data-sheet-header__share-block {
	display: flex;
	flex-direction: column-reverse;
	justify-content: flex-end;
	align-items: center;

	@media (--under-desktop) {
		zoom: 1.2;
	}

	@media (--desktop) {
		flex-direction: row;
	}

	& > :first-child svg {
		width: 24px;

		@media (--desktop) {
			margin: 0 16px 0 0;
		}
	}

	& button {
		border: 0;
		background-color: transparent;
		padding: 0;
	}
}

.real-estate-data__title {
	font-size: 20px;
	line-height: 25px;
	margin-bottom: 10px;
	text-transform: uppercase;

	@media (--tablet) {
		font-size: 24px;
	}
}

.real-estate-data__subtitle {
	font: 16px/20px 'regular', Arial, sans-serif;
	display: inline;
}

.m20-property-data-sheet-details__title {
	font-size: 24px;
}

.m20-property-data-sheet-details__lead {
	font-size: 18px;
	line-height: 24px;
	font-weight: 800px;
}

.m20-property-data-sheet-details__desc {
	font-size: 18px;
	line-height: 24px;
}

.real-estate-data .about-property {
	padding: 40px 0;
}

.m20-property-data-sheet-main-details__item img {
	@media (--under-desktop) {
		display: none;
	}
}

.m20-property-data-sheet-main-details__item--price {
	@media (--under-desktop) {
		background-color: var(--grey-f5);
		text-align: center;
		margin-bottom: 7px;
	}
}
.m20-property-data-sheet-main-details__item--price p {
	@media (--under-desktop) {
		background-color: var(--grey-f5);
		text-align: center;
		color: black;
		font-size: 24px;
		margin: 0 4px 0 0;
	}
}
</style>
